import React from "react";
import {Alert} from 'react-bootstrap'

function STCAlert(props){

    return(
        <Alert
            style={props.style}
            className={props.className}
            onClick={props.onClick}

            name={props.name}
            onChange={props.onChange}
            size={props.size}
            type={props.type}
            value={props.value}
            vertical={props.vertical}
            disabled={props.disabled}
            variant={props.variant}
            href={props.href}
            target={props.target}
        >
            {props.children}
        </Alert>
    )
}
export default STCAlert;